import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 768 768\" id=\"chevron-right\"><path d=\"M502.4 361.6l-192-192c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8L435.2 384 265.6 553.6c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 12.8 9.6 22.4 9.6s16-3.2 22.4-9.6l192-192c12.8-12.8 12.8-32 0-44.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/chevron-right.svg
// module id = dLUD
// module chunks = 1